import React from 'react';
import styles from './VideoSection.module.css';

const VideoSection: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.videoWrapper}>
          <iframe
            className={styles.iframe}
            src="https://www.youtube.com/embed/wBnWv-bc4Os"
            title="Brands2Buyers #2 édition 2025"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
